export const STEP_NODE = 124
export const STEP_ROW_SPACING = 40
export const STEP_ROW_PITCH = STEP_NODE + STEP_ROW_SPACING
export const STEP_PAIR_SPACING = 28
export const STEP_MILESTONE_SPACING = 40
// The milestone icon's centre from the card's leading and bottom edges.
export const STEP_MILESTONE_ICON_CENTER = 35

export type StepRow<T> =
  | { kind: 'single'; days: [T] }
  | { kind: 'pair'; days: [T, T] }

// Single-first 1-2-1-2…; a pair with one day left becomes a single.
export function stepRows<T>(days: T[]): StepRow<T>[] {
  const rows: StepRow<T>[] = []
  let i = 0
  while (i < days.length) {
    const wantsPair = rows.length % 2 === 1
    if (wantsPair && i + 1 < days.length) {
      rows.push({ kind: 'pair', days: [days[i], days[i + 1]] })
      i += 2
    } else {
      rows.push({ kind: 'single', days: [days[i]] })
      i += 1
    }
  }
  return rows
}

export function gridHeight(rowCount: number): number {
  if (rowCount === 0) return 0
  return rowCount * STEP_NODE + (rowCount - 1) * STEP_ROW_SPACING
}

// Node centres in row order (pair: left then right), relative to the column.
export function nodeCenters(
  rows: StepRow<unknown>[],
  columnWidth: number,
): { x: number; y: number }[] {
  const mid = columnWidth / 2
  const offset = (STEP_NODE + STEP_PAIR_SPACING) / 2
  return rows.flatMap((row, index) => {
    const y = index * STEP_ROW_PITCH + STEP_NODE / 2
    return row.kind === 'pair'
      ? [
          { x: mid - offset, y },
          { x: mid + offset, y },
        ]
      : [{ x: mid, y }]
  })
}
